// Shared helpers for uniform and weighted random selection.
/**
 * Returns a random integer from 0 up to, but not including, max.
 */
export function randomIndex(max) {
    if (!Number.isInteger(max) || max <= 0) {
        throw new Error('Cannot select a random index from a non-positive range');
    }
    return Math.floor(Math.random() * max);
}
/**
 * Selects a random item from a non-empty array.
 */
export function randomItem(items) {
    if (items.length === 0) {
        throw new Error('Cannot select from empty array');
    }
    return items[randomIndex(items.length)];
}
/**
 * Selects a random item from an array based on matching numeric weights.
 */
export function weightedRandomItem(items, weights) {
    if (items.length === 0) {
        throw new Error('Cannot select from empty array');
    }
    if (items.length !== weights.length) {
        throw new Error('Items and weights arrays must have the same length');
    }
    const cumulativeWeights = [];
    let sum = 0;
    for (const weight of weights) {
        sum += weight;
        cumulativeWeights.push(sum);
    }
    const random = Math.random() * sum;
    for (let i = 0; i < cumulativeWeights.length; i++) {
        if (random < cumulativeWeights[i]) {
            return items[i];
        }
    }
    return items[items.length - 1];
}
//# sourceMappingURL=randomSelection.js.map